<template>
  <mdb-container fluid>
    <error v-if="error" :error="error"/>
    <div v-if="!error && metaData">
      <h3 class="display-5 text-left text-primary" v-if="pageTitle"><span v-if="titleIcon">
        <mdb-icon size="lg" :icon="titleIcon"/>&nbsp;</span>{{ pageTitle }}
      </h3>
      <div class="text-left" v-if="navLinks && navLinks.length > 0 ">
        <mdb-btn v-for="(nav,i) in navLinks" :key="i"
                 size="sm" rounded :icon="nav.icon ? nav.icon : 'arrow-left'" @click="navToBack(i)">
          {{ (nav.label ? nav.label : 'Back') }}
        </mdb-btn>
      </div>
      <div class="card mb-4 p-2">
        <mdb-row>
          <mdb-col v-if="showAddButton" md="2" style="margin-top: auto; margin-bottom: auto;">
            <mdb-btn size="sm" rounded icon="plus-circle" @click="addHandler">{{ addLabel }}</mdb-btn>
          </mdb-col>
          <mdb-col :md="(showAddButton ? '10' : '12')">
            <mdb-input :disabled="executing" id="search-input" v-model="query"
                       aria-label="Search" label="Search"
                       type="text"
                       ariaDescribedBy="search-button"
                       @keydown.native="searchKeyDown"/>
          </mdb-col>
        </mdb-row>
        <mdb-row>
          <mdb-col md="12">
            <mdb-btn size="sm" id="search-button" @click="loadData('page')" icon="search"
                     class="mr-2">Search
            </mdb-btn>

            <mdb-btn size="sm" id="clear-button" @click="resetSearch" icon="minus-square"
                     class="mr-2">Reset
            </mdb-btn>

            <mdb-btn size="sm" id="add-filter" @click="addFilter" v-if="metaData.filters.length >0"
                     icon="filter" class="mr-2">Filter
            </mdb-btn>

            <mdb-btn size="sm" id="download" @click="showDownloadModal = true"
                     v-if="totalRows > 0 && totalRows < 5000"
                     icon="download">Download
            </mdb-btn>

            <mdb-btn size="sm" @click="changeSortModal=true"
                     v-if="viewAsCards"
                     icon="sort">Change Sort
            </mdb-btn>

            <mdb-btn size="sm" @click="doCompressColumns(true)"
                     v-if="!viewAsCards && identityColumn > -1 && !compressColumns "
                     icon="compress-alt">Compress {{ metaData.columns[identityColumn].label }} Cell
            </mdb-btn>

            <mdb-btn size="sm" @click="doCompressColumns(false)"
                     v-if="!viewAsCards && identityColumn > -1 && compressColumns "
                     icon="expand-alt">Expand {{ metaData.columns[identityColumn].label }} Cell
            </mdb-btn>
            <mdb-btn size="sm" @click="doViewAsCards(true)"
                     v-if="viewAsCards != true && identityColumn > -1"
                     icon="id-card">Tile View
            </mdb-btn>

            <mdb-btn size="sm" @click="doViewAsCards(false)"
                     v-if="viewAsCards && identityColumn > -1"
                     icon="table">Table View
            </mdb-btn>

          </mdb-col>
        </mdb-row>
        <mdb-row v-if="selectedFilters.length > 0" class="container">
          <span :key="i" v-for="(f,i) in selectedFilters">
            <div class="chip chip-sm primary-color white-text ripple-parent" color="primary-color" text="white">
              <span v-if="f.type != 'dateRange'">{{ f.label }} = {{ f.text }} <a @click.prevent="removeFilter(i)">
              <mdb-icon icon="times"></mdb-icon>
            </a></span>
              <span v-if="f.type == 'dateRange'">{{ f.label }} {{ formatDateRange(f)}}  <a @click.prevent="removeFilter(i)">
                <mdb-icon icon="times"></mdb-icon>
              </a></span>
            </div>
          </span>
        </mdb-row>
      </div>
      <div v-if="totalRows > 0" class="text-left">
        <b><i>{{ showingDisplay }} {{ totalDisplay }}</i></b>
      </div>
      <mdb-pagination circle>
        <mdb-page-nav v-if="pages > 10 && pageRange[0] != 1" @click.native="navTo(1)" prev></mdb-page-nav>
        <mdb-page-item v-for="n in pageRange" v-bind:key="n" :active="n == currentPage" @click.native="navTo(n)">{{
            n
          }}
        </mdb-page-item>
        <mdb-page-nav v-if="pages > 10 && pageRange[9] != pages" @click.native="navTo(pages)" next></mdb-page-nav>
      </mdb-pagination>

      <mdb-tbl v-if="( viewAsCards != true  || identityColumn == -1) && metaData" class="text-left" hover responsive
               striped>
        <mdb-tbl-head color="primary-color-dark" textWhite>
          <tr>
            <th>
              &nbsp;
            </th>
            <th v-for="(col,i) in metaData.columns" v-if="!col.hidden" v-bind:key="i">
              <span v-if="col.sortable">
                <span @click="doSort(col)" style="cursor: pointer">
                  <h5>{{ col.label }}
                    <mdb-icon icon="sort-down" v-if="sortColumn==col.field && sortOrder=='asc'"/>
                    <mdb-icon icon="sort-up" v-if="sortColumn==col.field && sortOrder=='desc'"/>
                  </h5>
                </span>
              </span>
              <span v-if="!col.sortable">
                <h5>{{ col.label }}</h5>
              </span>
            </th>
          </tr>
        </mdb-tbl-head>
        <mdb-tbl-body>
          <tr v-for="(row,i) in rows" v-show="!(row.id && deleted.includes(row.id))" v-bind:key="i">
            <td>
              <span v-if="actions && actions.length==1">
                <mdb-btn size="sm"
                         floating tag="a"
                         class="mt-2"
                         :aria-label="actions[0].label"
                         :title="actions[0].label"
                         :icon=" (actions[0].icon ? actions[0].icon : 'chevron-double-right')"
                         :color=" (actions[0].color ? actions[0].color : 'secondary-color')"
                         @click="handleAction(row, actions[0])"/>
              </span>
              <span v-if="actions && actions.length> 1">
                <mdb-dropdown>
                  <mdb-dropdown-toggle color="secondary" size="sm" slot="toggle"/>
                  <mdb-dropdown-menu>
                    <mdb-dropdown-item v-for="(a,i) in actions" :key="i" @click="handleAction(row, a)"
                                       :aria-label="a.label"
                                       :class=" (a.class ? a.class : '')"
                                       :title="a.label">
                      <mdb-icon v-if="a.icon" :icon="a.icon"/>
                      {{ a.label }}
                    </mdb-dropdown-item>
                  </mdb-dropdown-menu>
                </mdb-dropdown>
              </span>

            </td>
            <td v-for="(col,i) in metaData.columns" v-if="!col.hidden" v-bind:key="i"
                :class="determineClass(col.type)">

              <span v-if="!col.type">{{ row[col.field] }}</span>
              <span v-if="col.type=='number'">{{ row[col.field] }}</span>
              <span v-if="col.type=='checkbox'">
                <mdb-input :id="'checkbox-'+i" v-model="row[col.field]" disabled type="checkbox"/>
              </span>
              <span v-if="col.type=='avatar'">
                <avatar :avatar="row[col.field]" :size="50" container-class=""/>
              </span>
              <span v-if="col.type=='boolean'">
                <mdb-icon icon="check" v-if="row[col.field]==true"/>
              </span>
              <span v-if="col.type=='image' && row[col.field]">
                <img :src="row[col.field]" :width="col.size ? col.size : '100px'"/>
              </span>
              <span v-if="col.type=='badge' && row[col.field]">
                <mdb-badge :color="col.badgeColor ? col.badgeColor : 'success'">{{ row[col.field] }}</mdb-badge>
              </span>
              <span v-if="col.type=='identity'">
                <avatar v-if="col.hasOwnProperty('avatar') && col.hasOwnProperty('reputation') && !compressColumns"
                        :reputation="row[col.reputation]"
                        :avatar="row[col.avatar]" :size="50"/>
                <avatar v-if="col.hasOwnProperty('avatar') && !col.hasOwnProperty('reputation') && !compressColumns"
                        :avatar="row[col.avatar]" :size="50" container-class=""/>
                <h5>{{ row[col.field] }}</h5>
                <h6 v-if="col.hasOwnProperty('title') && !compressColumns">{{ row[col.title] }}</h6>
                <span v-if="col.hasOwnProperty('badge') && row[col.badge] && !compressColumns">
                  <mdb-badge
                    :color="(row.badgeColor ? row.badgeColor : (col.badgeColor ? col.badgeColor : 'success')) ">
                    {{ row[col.badge] }}
                  </mdb-badge>
                </span>
              </span>
            </td>
          </tr>
        </mdb-tbl-body>
      </mdb-tbl>

      <mdb-row v-if="rows && rows.length>0 && viewAsCards && identityColumn > -1">
        <div v-for="(row,i) in rows" :key="i" class="col-lg-3 col-md-12 d-flex align-self-stretch">
          <mdb-card class="mb-4" style="width:100%">
            <mdb-card-body cascade>
              <avatar
                v-if="metaData.columns[identityColumn].hasOwnProperty('avatar') && metaData.columns[identityColumn].hasOwnProperty('reputation')"
                :reputation="row[metaData.columns[identityColumn].reputation]"
                :avatar="row[metaData.columns[identityColumn].avatar]" :size="100"/>
              <avatar
                v-if="metaData.columns[identityColumn].hasOwnProperty('avatar') && !metaData.columns[identityColumn].hasOwnProperty('reputation')"
                :avatar="row[metaData.columns[identityColumn].avatar]" :size="100" container-class=""/>
              <h5>{{ row[metaData.columns[identityColumn].field] }}</h5>
              <h6 v-if="metaData.columns[identityColumn].hasOwnProperty('title')">
                {{ row[metaData.columns[identityColumn].title] }}</h6>
              <span
                v-if="metaData.columns[identityColumn].hasOwnProperty('badge') && row[metaData.columns[identityColumn].badge]">
                <mdb-badge
                  :color="(row.badgeColor ? row.badgeColor : (metaData.columns[identityColumn].badgeColor ? metaData.columns[identityColumn].badgeColor : 'success')) ">
                  {{ row[metaData.columns[identityColumn].badge] }}
                </mdb-badge>
              </span>
              <div v-if="actions && actions.length==1">
                <mdb-btn size="sm"
                         floating tag="a"
                         class="mt-2"
                         :aria-label="actions[0].label"
                         :title="actions[0].label"
                         :icon=" (actions[0].icon ? actions[0].icon : 'chevron-double-right')"
                         :color=" (actions[0].color ? actions[0].color : 'secondary-color')"
                         @click="handleAction(row, actions[0])"/>
              </div>
              <mdb-dropdown v-if="actions && actions.length > 1">
                <mdb-dropdown-toggle color="secondary" size="sm" slot="toggle"/>
                <mdb-dropdown-menu>
                  <mdb-dropdown-item v-for="(a,i) in actions" :key="i" @click="handleAction(row, a)"
                                     :aria-label="a.label"
                                     :class=" (a.class ? a.class : '')"
                                     :title="a.label">
                    <mdb-icon v-if="a.icon" :icon="a.icon"/>
                    {{ a.label }}
                  </mdb-dropdown-item>
                </mdb-dropdown-menu>
              </mdb-dropdown>
            </mdb-card-body>
          </mdb-card>

        </div>
      </mdb-row>

      <mdb-pagination circle class="mb-4">
        <mdb-page-nav v-if="pages > 10 && pageRange[0] != 1" @click.native="navTo(1)" prev></mdb-page-nav>
        <mdb-page-item v-for="n in pageRange" v-bind:key="n" :active="n == currentPage" @click.native="navTo(n)">{{ n }}
        </mdb-page-item>
        <mdb-page-nav v-if="pages > 10 && pageRange[9] != pages" @click.native="navTo(pages)" next></mdb-page-nav>
      </mdb-pagination>

      <mdb-row v-if="totalRows == 0" class="container">
        <i>No records were found.</i>
      </mdb-row>
    </div>

    <mdb-modal v-if="showAddFilter" size="lg" scrollable @close="closeFilter">
      <mdb-modal-header :close="true" class="primary-color text-white">
        <h4>{{ (addingFilter >= 0 ? metaData.filters[addingFilter].label + ' Filter' : 'Filter On') }}</h4>
      </mdb-modal-header>
      <mdb-modal-body>
        <div v-if="addingFilter < 0 ">
          <div>
            <mdb-card class="mb-2">
              <mdb-card-header class="secondary-color">
                <h5>Criteria</h5>
              </mdb-card-header>
              <mdb-card-body>
                <mdb-btn size="sm" v-for="(f,i) in metaData.filters"
                         v-show="allowFilter(f)"
                         :key="i" @click="selectFilter(i)">{{ f.label }}
                </mdb-btn>
              </mdb-card-body>
            </mdb-card>
          </div>
          <mdb-card v-if="metaData.quickFilters && metaData.quickFilters.length > 0">
            <mdb-card-header class="secondary-color">
              <h5>Quick Filters</h5>
            </mdb-card-header>
            <mdb-card-body>
              <mdb-btn size="sm" v-for="(f,i) in metaData.quickFilters"
                       :key="i" @click="quickFilter(f)">{{ f.name }}
              </mdb-btn>
            </mdb-card-body>
          </mdb-card>
          <div>
            <mdb-btn size="sm" rounded color="warning" @click="closeFilter" icon="minus-circle">Cancel</mdb-btn>
          </div>
        </div>
        <div v-if="addingFilter >= 0 ">
          <div v-for="(f,i) in metaData.filters[addingFilter].values" :key="i">
            <mdb-btn size="sm"
                     v-if="!isFilterItemSelected(metaData.filters[addingFilter], f.value)"
                     @click="selectFilterItem(i)"
                     style="min-width: 55%">{{ f.text }}
            </mdb-btn>
          </div>
          <div v-if="metaData.filters[addingFilter].type == 'dateRange'">

            <label class="active mr-5">From</label>
            <date-picker
              type="date"
              :format="userDetails.dateFormat.toUpperCase()"
              value-type="date"
              editable
              :clearable="true"
              v-model="filterFromDate"
            />
            <label class="active mr-5">Through</label>
            <date-picker
              type="date"
              :format="userDetails.dateFormat.toUpperCase()"
              value-type="date"
              editable
              :clearable="true"
              v-model="filterThruDate"
            />

          </div>
          <div>
            <mdb-btn size="sm" rounded color="warning" @click="addingFilter=-1" icon="minus-circle">Back</mdb-btn>
            <mdb-btn size="sm" rounded color="success" v-if="metaData.filters[addingFilter].type != 'dateRange'" @click="closeFilter" icon="minus-circle">Go</mdb-btn>
            <mdb-btn size="sm" rounded color="success" v-if="metaData.filters[addingFilter].type == 'dateRange'" @click="addDateFilter" icon="minus-circle">Go</mdb-btn>
          </div>
        </div>
      </mdb-modal-body>
    </mdb-modal>

    <mdb-modal v-if="changeSortModal" size="lg" scrollable @close="changeSortModal = false">
      <mdb-modal-header :close="true" class="primary-color text-white">
        <h4>Change Sort</h4>
      </mdb-modal-header>
      <mdb-modal-body>
        <mdb-switch :checked="modalSort" offLabel="Sort Down" onLabel="Sort Up"
                    @getValue="modalSort = !modalSort"/>
        <div v-for="(col,i) in metaData.columns" :key="i" v-if="!col.hidden && col.sortable">
          <mdb-btn size="sm" style="min-width: 200px" @click="changeSort(col)">{{ col.label }}</mdb-btn>
        </div>
      </mdb-modal-body>

    </mdb-modal>

    <mdb-modal v-if="showDownloadModal" size="lg" scrollable @close="showDownloadModal=false">
      <mdb-modal-header :close="true" class="primary-color text-white">
        <h4>Download Data</h4>
      </mdb-modal-header>
      <mdb-modal-body>
        <div>
          <mdb-btn size="sm" rounded color="success" @click="loadData('csv')" icon="file-csv">Export as CSV</mdb-btn>
          <mdb-btn size="sm" rounded color="success" @click="loadData('xls')" icon="file-spreadsheet">Export as XLS
          </mdb-btn>
          <mdb-btn size="sm" rounded @click="showDownloadModal=false" icon="minus-circle">Cancel</mdb-btn>
        </div>

      </mdb-modal-body>

    </mdb-modal>

  </mdb-container>
</template>

<script>
import api from '../../services/groupsPlaceApi.js'
import DatePicker from 'vue2-datepicker'
import {
  mdbBadge,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbCardImage,
  mdbChip,
  mdbCol,
  mdbContainer,
  mdbDropdown,
  mdbDropdownItem,
  mdbDropdownMenu,
  mdbDropdownToggle,
  mdbFormInline,
  mdbIcon,
  mdbInput,
  mdbMask,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbPageItem,
  mdbPageNav,
  mdbPagination,
  mdbRow,
  mdbSelect,
  mdbSwitch,
  mdbTbl,
  mdbTblBody,
  mdbTblHead,
  mdbView
} from 'mdbvue';
import Error from '../common/Error'
import Avatar from "./Avatar";
import download from 'js-file-download'
import moment from "moment";

export default {
  name: 'advanced-data-table',
  components: {
    mdbBadge,
    mdbTbl,
    mdbTblBody,
    mdbTblHead,
    mdbContainer,
    mdbFormInline,
    mdbIcon,
    mdbInput,
    mdbBtn,
    mdbRow,
    mdbCol,
    mdbPagination,
    mdbPageNav,
    mdbPageItem,
    mdbChip,
    mdbCard,
    mdbCardHeader,
    mdbCardImage,
    mdbView,
    mdbMask,
    mdbCardBody,
    mdbSelect,
    mdbSwitch,
    mdbDropdown,
    mdbDropdownToggle,
    mdbDropdownMenu,
    mdbDropdownItem,
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    Error,
    Avatar,
    DatePicker

  },
  computed: {
    executing: function () {
      return this.$store.state.executing
    },
    settings: function () {
      return this.$store.state.settings
    },
    reloadTable: function () {
      return this.$store.state.dataTableReloadEvent
    },
    updateTableRow: function () {
      return this.$store.state.updateTableRow
    },
    insertTableRow: function () {
      return this.$store.state.insertTableRow
    },
    deleteTableRow: function () {
      return this.$store.state.deleteTableRow
    },
    userDetails: function() {
      return this.$store.state.userDetails
    }
  },
  props: {
    pageTitle: {
      type: String,
      default: null
    },
    titleIcon: {
      type: String,
      default: null
    },
    queryName: {
      type: String,
      default: null
    },
    actions: {
      type: Array,
      default: function () {
        return []
      }
    },
    deleted: {
      type: Array,
      default: function () {
        return []
      }
    },
    showAddButton: {
      type: Boolean,
      default: false
    },
    cardConfig: {
      type: Object,
      default: null
    },
    addHandler: {
      type: Function,
      default: function (id) {

      }
    },
    addLabel: {
      type: String,
      default: "Create New"
    },
    forceQuery: {
      type: String,
      default: null
    },
    additionalParameters: {
      type: Object,
      default: null
    },
    navLinks: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data() {
    return {
      error: null,
      metaData: null,
      totalRows: 0,
      rows: [],
      offset: 0,
      showingDisplay: "",
      totalDisplay: "",
      query: "",
      isTyping: false,
      pages: 0,
      currentPage: 1,
      pageRange: [],
      selectedFilters: [],
      showAddFilter: false,
      addingFilter: null,
      sortColumn: null,
      sortOrder: "asc",
      showDownloadModal: false,
      downloadName: "download",
      changeSortModal: false,
      viewAsCards: true,
      identityColumn: -1,
      modalSort: true,
      compressColumns: false,
      filterFromDate: null,
      filterThruDate: null
    };
  },
  async mounted() {
    if (!this.queryName) {
      console.error("Query Name was not set in component.")
      return
    }
    if (!this.metaData) await this.loadMetaData()
    if (!this.metaData) return
    if (this.forceQuery) {
      this.query = this.forceQuery
    } else {
      this.getSavedSettings()
      if (this.selectedFilters.length == 0 && this.metaData.defaultFilters) {
        this.selectedFilters = this.metaData.defaultFilters
      }
    }
    this.loadData('page')
    if (this.pageTitle) document.title = this.pageTitle
  },
  watch: {
    forceQuery: function (value) {
      if (!value) return
      this.query = this.forceQuery
      this.selectedFilters = []
      this.loadData('page')
    },
    reloadTable: function (value) {
      if (value) {
        this.loadData('page')
        this.$store.dispatch("setDataTableReload", false)
      }
    },
    insertTableRow: function (value) {
      if (value && value.tableId == this.queryName) {
        this.rows.unshift(value.data)
        this.$store.dispatch("insertTableRow", null)
      }
    },
    updateTableRow: function (value) {
      if (value && value.data && value.tableId == this.queryName) {
        for (let i = 0; i <= this.rows.length; i++) {
          if (this.rows[i] && this.rows[i].id == value.data.id) {
            this.rows[i] = value.data
          }
        }
        this.$store.dispatch("updateTableRow", null)
      }
    },
    deleteTableRow: function (value) {
      let loc = -1
      if (value && value.data && value.tableId == this.queryName) {
        for (let i = 0; i <= this.rows.length; i++) {
          if (this.rows[i] && this.rows[i].id == value.data.id) {
            loc = i
          }
        }
        if (loc > -1) this.rows.splice(loc, 1)
        this.$store.dispatch("updateTableRow", null)
      }
    }
  },
  methods: {
    resetPagination() {
      this.currentPage = 1
      this.offset = 0
    },
    formatDateRange(f) {
      if (f.fromDate && !f.thruDate) return " on or after " + moment(f.fromDate).format(this.userDetails.dateFormat.toUpperCase())
      if (!f.fromDate && f.thruDate) return " on or before " + moment(f.thruDate).format(this.userDetails.dateFormat.toUpperCase())
      return " between" + moment(f.fromDate).format(this.userDetails.dateFormat.toUpperCase()) + " and " + moment(f.thruDate).format(this.userDetails.dateFormat.toUpperCase())
    },
    navToBack(i) {
      let link = this.navLinks[i]
      if (link.target) {
        this.$router.push(link.target)
      }
    },
    doViewAsCards(val) {
      this.viewAsCards = val
      this.saveSettings()
    },
    doCompressColumns(val) {
      this.compressColumns = val
      this.saveSettings()
    },
    async loadMetaData() {
      await this.$store.dispatch("setExecuting", false)
      await api.post("/query/meta/" + this.queryName, {additionalParameters: this.additionalParameters}).then(
        (response) => {
          this.metaData = response.data
          let i = -1
          for (let col of this.metaData.columns) {
            i++
            if (col.type == "identity") this.identityColumn = i
          }
          if (this.identityColumn == -1) this.viewAsCards = false
        },
        (error) => {
          if (error.response.status == 403) {
            this.$router.push("/403")
          } else {
            this.error = error
          }
        }
      ).then(() => {
        this.$store.dispatch("setExecuting", false)
      });
    },
    determineClass(type) {
      //col.type=='number' ? 'text-right' : ( (col.type=='image' || col.type=='avatar' ||  col.type=='boolean') ? 'text-center' : 'text-left')
      if (type == "number") return "text-right"
      if (type == "image" || type == "avatar" || type == "boolean") return "text-center"
      if (type == "identity") return "text-center secondary-color"
      return "text-left"
    },
    handleAction(row, action) {
      this.$emit("handleAction", row, action.name)
    },
    changeSort(col) {
      this.sortColumn = col.field
      this.sortOrder = (this.modalSort ? "asc" : "desc")
      this.changeSortModal = false
      this.loadData('page')
    },
    doSort(col) {
      if (this.sortColumn == col.field) {
        if (this.sortOrder == "asc") this.sortOrder = "desc"
        else this.sortOrder = "asc"
      } else this.sortOrder = "asc"
      this.sortColumn = col.field
      this.loadData('page')
    },
    getSavedSettings() {
      let saved = localStorage.getItem("data-table-" + this.queryName)
      if (saved) {
        try {
          saved = JSON.parse(saved)
          this.query = saved.query
          this.sortOrder = saved.sortOrder
          this.sortColumn = saved.sortColumn
          this.selectedFilters = saved.selectedFilters
          this.compressColumns = saved.compressColumns
          this.viewAsCards = saved.viewAsCards
        } catch (e) {
          console.error("Could not parse saved settings. Removing.")
          localStorage.removeItem("data-table-" + this.queryName)
        }
      }
    },
    saveSettings() {
      if (this.query && (this.query.indexOf("id:") >= 0 || this.query.indexOf("view:") >= 0)) return
      let settings = {
        query: this.query, sortColumn: this.sortColumn,
        sortOrder: this.sortOrder, selectedFilters: this.selectedFilters,
        compressColumns: this.compressColumns, viewAsCards: this.viewAsCards
      }
      localStorage.setItem("data-table-" + this.queryName, JSON.stringify(settings))
    },
    removeFilter(i) {
      this.resetPagination()
      this.selectedFilters.splice(i, 1)
      this.loadData('page')
    },
    allowFilter: function (filter) {
      if (!filter.hasOwnProperty("allowMultiple")) return true
      if (filter.allowMultiple == false && this.isFilterSelected(filter)) return false
      return true
    },
    isFilterSelected(filter) {
      let ret = false
      for (let f of this.selectedFilters) {
        if (f.name == filter.name) ret = true
      }
      return ret
    },
    isFilterItemSelected(filter, value) {
      let ret = false
      for (let f of this.selectedFilters) {
        if (f.name == filter.name && f.value == value) ret = true
      }
      return ret
    },
    addDateFilter() {
      if (this.filterFromDate || this.filterThruDate) {
        this.selectedFilters.push({
                                    name: this.metaData.filters[this.addingFilter].name,
                                    label: this.metaData.filters[this.addingFilter].label,
                                    type: this.metaData.filters[this.addingFilter].type,
                                    fromDate: this.filterFromDate,
                                    thruDate: this.filterThruDate
                                  })
      }

        this.closeFilter()

    },
    selectFilterItem(i) {
      this.selectedFilters.push({
                                  name: this.metaData.filters[this.addingFilter].name,
                                  label: this.metaData.filters[this.addingFilter].label,
                                  text: this.metaData.filters[this.addingFilter].values[i].text,
                                  value: this.metaData.filters[this.addingFilter].values[i].value,
                                })
      if (this.metaData.filters[this.addingFilter].hasOwnProperty("allowMultiple") && this.metaData.filters[this.addingFilter].allowMultiple === false) {
        this.closeFilter()
      }
    },
    selectFilter(i) {
      this.addingFilter = i
    },
    quickFilter(f) {
      this.resetPagination()
      this.selectedFilters = f.filters
      this.showAddFilter = false
      this.loadData('page')
    },
    addFilter() {
      this.addingFilter = -1
      this.showAddFilter = true
    },
    closeFilter() {
      this.resetPagination()
      this.showAddFilter = false
      this.addingFilter = -1
      this.loadData('page')
    },
    searchKeyDown(n) {
      if (n.keyCode == 13) {
        this.resetPagination()
        this.loadData('page')
      }
    },
    resetSearch() {
      this.resetPagination()
      if (this.query && (this.query.indexOf("id:") >= 0 || this.query.indexOf("view:") >= 0)) {
        this.getSavedSettings()
      } else {
        this.query = ""
        this.selectedFilters = []
      }
      this.loadData('page')
    },
    navTo: function (n) {
      this.currentPage = n
      this.offset = (n - 1) * 24
      this.loadData('page')
    },
    calculatePagination: function () {
      this.pageRange = []
      if (this.pages == 1) return
      let rangeStart = 0
      if (this.pages <= 10) {
        rangeStart = 1
      } else {
        rangeStart = this.currentPage - 1
        if (rangeStart + 10 > this.pages) rangeStart = this.pages - 9
      }
      if (rangeStart < 1) rangeStart = 1
      let max = (this.pages > 10 ? 10 : this.pages)
      for (let i = 0; i < max; i++) {
        const p = i + rangeStart
        if (p <= this.pages) this.pageRange.push(p)
      }

    },
    excelDownload: function (payload) {
      this.$store.dispatch("setExecuting", true)
      api.postBlob("/query/execute/" + this.queryName, payload).then(
        (response) => {
          download(response.data, this.downloadName + "." + payload.format)
        },
        (error) => {
          this.error = error
        }
      ).then(() => {
        this.$store.dispatch("setExecuting", false)
      });
    },
    loadData: function (format) {
      this.showDownloadModal = false
      let payload = {
        query: this.query, sortColumn: this.sortColumn, max: format == 'page' ? 24 : 5000,
        offset: format == 'page' ? this.offset : 0,
        sortOrder: this.sortOrder, selectedFilters: this.selectedFilters, format: format,
        additionalParameters: this.additionalParameters
      }

      if (payload.format == "xls") {
        this.excelDownload(payload)
        return
      }

      this.$store.dispatch("setExecuting", true)

      api.post("/query/execute/" + this.queryName, payload).then(
        (response) => {
          if (payload.format != 'page') {
            download(response.data, this.downloadName + "." + payload.format)
          } else {
            if (!this.forceQuery) this.saveSettings()
            this.$store.dispatch("setExecuting", true)
            this.rows = null
            this.totalRows = 0
            if (response.data.downloadName) this.downloadName = response.data.downloadName
            this.rows = response.data.rows
            this.totalRows = response.data.total
            if (!this.totalRows) this.totalRows = 0
            if (this.forceQuery) {
              if (this.totalRows == 1) this.$emit("forcedRowLoaded", this.rows[0])
            }
            if (this.totalRows == this.rows.length) {
              this.showingDisplay = "Showing all rows"
              this.totalDisplay = " (" + this.totalRows + ")"
            } else {
              const start = (this.offset + 1)
              let end = (start + 23)
              if (this.rows.length < 24) end = (this.rows.length + this.offset)
              this.showingDisplay = "Showing rows " + start + " - " + end
              this.totalDisplay = " of " + this.totalRows
            }
            if (this.totalRows <= 24) this.pages = 1
            else {
              this.pages = Math.round(this.totalRows / 24)
              if ((this.pages * 24) < this.totalRows) this.pages++
            }
            this.calculatePagination()
          }

        },
        (error) => {
          if (error.response.status == 403) {
            this.$router.push("/403")
          } else {
            this.error = error
          }
        }
      ).then(() => {
        this.$store.dispatch("setExecuting", false)
        if (window.innerWidth < 760) return //focus can be annoying on small devices!
        this.$nextTick().then(() => {
          let el = document.getElementById("search-input");
          if (el) {
            el.focus();
            el.setSelectionRange(el.value.length, el.value.length)
          }
        })
      });

    },
    refresh: function () {
      this.loadPage()
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.clickable {
  cursor: pointer;
}
</style>
